import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, inject, ViewChild } from '@angular/core';

import { TabIdentityService } from './tab-identity.service';

const SWITCHED_MESSAGE = 'TablesReady was switched to a different account or location in another tab.';
const SIGNED_OUT_MESSAGE = 'You signed out of TablesReady in another tab.';

@Component({
  selector: 'tr-stale-tab-overlay',
  standalone: true,
  imports: [AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (lock$ | async; as lock) {
      <div class="stale-tab-overlay" role="alertdialog" aria-modal="true" aria-labelledby="stale-tab-title"
           aria-describedby="stale-tab-message" data-testid="stale-tab-overlay">
        <div class="stale-tab-overlay__card">
          <h2 id="stale-tab-title">This tab is out of date</h2>
          <p id="stale-tab-message" data-testid="stale-tab-message">
            {{ lock.signedOut ? signedOutMessage : switchedMessage }} Reload this tab to continue.
          </p>
          <button #reloadButton type="button" class="btn btn-primary" data-testid="stale-tab-reload"
                  (click)="reload()">
            Reload
          </button>
        </div>
      </div>
    }
  `,
  styles: [`
    .stale-tab-overlay {
      position: fixed;
      inset: 0;
      z-index: 100000;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--ion-background-color, var(--ion-color-light));
      color: var(--ion-text-color, var(--ion-color-dark));
    }

    .stale-tab-overlay__card {
      max-width: 28rem;
      padding: 1.5rem;
      text-align: center;
    }
  `],
})
export class StaleTabOverlayComponent {
  readonly lock$ = inject(TabIdentityService).lock$;
  readonly switchedMessage = SWITCHED_MESSAGE;
  readonly signedOutMessage = SIGNED_OUT_MESSAGE;

  // Set when the overlay appears: keyboard focus starts on Reload, not on the screen behind it.
  @ViewChild('reloadButton')
  set reloadButton(button: ElementRef<HTMLButtonElement> | undefined) {
    button?.nativeElement.focus();
  }

  reload(): void {
    window.location.reload();
  }
}
